import { ArrowUpRight, FileText, Mic, Video, Newspaper } from "lucide-react";
import { Seo } from "@/components/site/Seo";
import { PageIntro } from "@/components/site/PageIntro";
import { interviews } from "@/data/interviews";
import { useLang } from "@/i18n";

const ICONS = { PDF: FileText, Wideo: Video, Audio: Mic };
const GALLERY = ["/images/extra3.jpg", "/images/extra1.jpg", "/images/extra2.jpg"];

const InterviewCard = ({ item, idx, m }) => {
  const Icon = ICONS[item.type] || Newspaper;
  const { title, source } = m.items[item.id];
  return (
    <a href={item.href} target="_blank" rel="noopener noreferrer" data-testid={`interview-card-${item.id}`}
      className="card-lift group bg-[#F8F6F0] border border-[#D3CEC4] rounded-2xl overflow-hidden flex flex-col reveal" style={{ animationDelay: `${idx * 0.06}s` }}>
      <div className="aspect-[4/3] overflow-hidden bg-[#EAE5D9] relative">
        <img src={item.thumbnail} alt={title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" />
        <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#1A2522]/85 backdrop-blur text-[#F8F6F0] text-[10px] tracking-[0.2em] uppercase font-semibold">
          <Icon className="w-3.5 h-3.5" /> {m.types[item.type]}
        </span>
      </div>
      <div className="p-6 sm:p-7 flex flex-col flex-1">
        <p className="text-[10px] tracking-[0.28em] uppercase font-semibold text-[#374F49]">{source}</p>
        <h2 className="font-serif text-xl sm:text-[19.5px] mt-3 leading-snug text-[#1A2522] flex-1">{title}</h2>
        <div className="mt-6 inline-flex items-center gap-2 text-[12px] tracking-[0.2em] uppercase font-semibold text-[#374F49] group-hover:text-[#1A2522] transition-colors">
          {m.read} <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </div>
      </div>
    </a>
  );
};

export default function Interviews() {
  const m = useLang().t.interviews;
  return (
    <>
      <Seo page="interviews" />
      <PageIntro testId="interviews-intro" overline={m.overline} title={m.title} lead={m.lead} />
      <section data-testid="interviews-section" className="max-w-7xl mx-auto px-6 sm:px-12 pb-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {interviews.map((item, idx) => (
            <InterviewCard key={item.id} item={item} idx={idx} m={m} />
          ))}
        </div>
      </section>
      <section data-testid="press-gallery" className="max-w-7xl mx-auto px-6 sm:px-12 pb-24 sm:pb-32">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {GALLERY.map((src, i) => (
            <div key={src} className="overflow-hidden rounded-2xl aspect-[16/10] bg-[#EAE5D9]" data-testid={`press-image-${i}`}>
              <img src={src} alt={`${m.galleryAlt} ${i + 1}`} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" loading="lazy" />
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
